import { formatPrice } from '@nespresso/catalog-sdk'
import classNames from 'classnames'
import { useEffect, useState } from 'preact/hooks'
import styles from './Price.module.scss'

type ProductPriceProps = {
    price: number
    priceDark?: boolean
}

export default function Price({ price, priceDark }: ProductPriceProps) {
    const [formattedPrice, setFormattedPrice] = useState('')

    useEffect(() => {
        const format = async () => {
            if (price) {
                try {
                    const formatted = await formatPrice(price)
                    setFormattedPrice(formatted)
                } catch (e) {
                    console.error('Could not format price')
                    console.log(e)
                }
            }
        }
        format()
    }, [price])

    if (!price || !formattedPrice) {
        return null
    }

    return (
        <span
            className={classNames(
                't-2xs-500-sl',
                styles.price,
                priceDark ? styles.priceDark : ''
            )}>
            {formattedPrice}
        </span>
    )
}
